import React, { useEffect, useState } from 'react';
import ContainerCard                  from '../../reuseableComponents/CardComponent/ContainerCard/ContainerCard';
import HeadingNDescription     from '../../reuseableComponents/headingNDescription/headingNDescription';
import "./allSavedProperties.scss"
import Loader                         from '../../reuseableComponents/Loader/Loader';
import Notification            from '../../reuseableComponents/Notification';
import { getSavedPropertiesApi } from './apis/apis';

const AllSavedProperties = () => {
  const [state, setState] = useState({
    savedProperties:[],
    loader:false
  })
  const getSavedProperties = async () => {
    setState({
      ...state,
      loader: true
    })
    let result = await getSavedPropertiesApi()
    if (result?.data?.data) {
      setState({
        ...state,
        savedProperties: result?.data?.data,
        loader: false
      })
    }
    else {
      Notification('error', "Error", "Error.");
      setState({
        ...state,
        loader: false
      })
    }
  }

  useEffect(() => {
    getSavedProperties()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state.loader ? <Loader/> : <div className={ "allSaved all-container" }>
    <div className={"savedProperties"}></div>
    <HeadingNDescription
      style={{
        paddingTop:0,
        marginTop:0
      }}
      heading={ "All Saved Properties" }
                         description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }/>
    {
      state.savedProperties.length > 0 && <div style={ {
      marginTop: 50,
      width:"90%",
      margin:"auto"
    } }>
      <ContainerCard cardType={ "saved" } data={ state.savedProperties } getProperties={getSavedProperties}/>
    </div>
    }
  </div>
}

export default AllSavedProperties